import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { VoucherresponseComponent } from "./View/Voucher/Voucherresponse.component";
import { PublicComponent } from "./View/public/public.component";
import { PUBLIC_ROUTES } from "./View/public/public.route";

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  useHash: false,
};

const routes: Routes = [
  {
    path: "",
    component: PublicComponent,
    children: PUBLIC_ROUTES,
  },
  { path: "UPIresponse", component: VoucherresponseComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { ...routerOptions, useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
